import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "delete-red--sprite",
  "use": "delete-red--sprite-usage",
  "viewBox": "0 0 22.556 29",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22.556 29\" id=\"delete-red--sprite\"><defs><style>#delete-red--sprite .a{fill:#8b0000;}</style></defs><path class=\"a\" d=\"M27.556,4.611H21.917L20.306,3H12.25L10.639,4.611H5V7.833H27.556M6.611,28.778A3.222,3.222,0,0,0,9.833,32H22.722a3.222,3.222,0,0,0,3.222-3.222V9.444H6.611Z\" transform=\"translate(-5 -3)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol